module.exports = __webpack_public_path__ + "static/oldManMobile-b495417bb642350e5c5430345b66e614.png";